const radioType = ['1', '4']
const checkType = ['2', '5']
const showOptionsType = ['1', '2', '4', '5']
const showAnalysisType = ['1', '2', '3', '4', '5', '6', '7', '10', '11', '12','13','20','21','22']
const showJudgeAnswerType = ['3']
const showSortType = ['7']
const showRichTextAnswerType = ['9','13','17','18','19','20','21','22']
const requireFileType = ['4', '5', '8', '9', '11', '15']
const isLineQuestionType = ['6']
const isHideAnswerType = ['8', '9']
const isclozeType = ['10', '11', '12']
const isAudioClozeType = ['11']
const isBigClozeType = ['16']
export const isBigClozeChildrenType = '1'
const isQuestionGroupType = ['14', '15', '16']

const limitQuestionLengthByTypeDefaultLength = {
  '1': 4,
  '4': 2,
  '2': 3,
  '5': 3,
  '6': 2,
  '7': 2
}

const limitQuestionLengthByTypeMinLength = {
    1: 2,
    4: 2,
    2: 3,
    5: 3,
    6: 2,
    7: 2,
};

const limitQuestionLengthByTypeMaxLength = {
  '1': 15,
  '4': 10,
  '2': 10,
  '5': 10,
  '6': 10,
  '7': 10,
  '10': 25,
  '11': 25,
  '12': 25
}

export const isRadio = (type) => {
  return radioType.includes((type))
}

export const isCheck = type => checkType.includes(type)

export const showOptions = type => showOptionsType.includes(type)

export const showAnalysis = type => showAnalysisType.includes(type)

export const showJudgeAnswer = type => showJudgeAnswerType.includes(type)

export const showSort = type => showSortType.includes(type)

export const requireFile = type => requireFileType.includes(type)

export const showRichTextAnswer = type => showRichTextAnswerType.includes(type)

export const isHideAnswer = type => isHideAnswerType.includes(type)

export const isLineQuestion = type => isLineQuestionType.includes(type)

export const isCloze = type => isclozeType.includes(type)

export const isQuestionGroup = type => isQuestionGroupType.includes(type)

export const optionsMinLength = type => limitQuestionLengthByTypeMinLength[type]

export const optionsMaxLength = type => limitQuestionLengthByTypeMaxLength[type]

export const optionsDefaultLength = (type) =>
    limitQuestionLengthByTypeDefaultLength[type];

export const isAudioCloze = type => isAudioClozeType.includes(type)

export const isBigCloze = type => isBigClozeType.includes(type)
